import {
  Component,
  inject,
  OnDestroy,
  OnInit,
  Signal
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../../../../../common/spinner/spinner.component';
import { ApplicantForm } from './forms/applicant.form';
import { toObservable } from '@angular/core/rxjs-interop';
import {
  updateApplicantData
} from '../../../../../store/actions/application.actions';
import { StagesComponent } from '../../../../../common/stages/stages.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ValidationErrorsComponent } from '../../../../../common/validation-errors/validation-errors.component';
import { ApplicationCommonComponent } from '../application.common.component';
import { ProxyFormComponent } from './components/proxy-person-form/proxy-form.component';
import { SessionService } from '../../../../../services/ssession.service';
import { UserDetails } from '../../../../../store/reducers/user-details.reducer';
import { selectUser } from '../../../../../store/selectors/user-details.selectors';
import {
  ApplicantPeselDataFormComponent
} from './components/applicant-pesel-data-form/applicant-pesel-data-form.component';
import { ApplicantNipDataFormComponent } from './components/applicant-nip-data-form/applicant-nip-data-form.component';
import {
  ApplicantNoNipAndPeselDataFormComponent
} from './components/applicant-no-nip-and-pesel-data-form/applicant-no-nip-and-pesel-data-form.component';
import {
  ApplicantAddressDataFormComponent
} from './components/applicant-address-data-form/applicant-address-data-form.component';
import { NgxMaskDirective } from 'ngx-mask';
import { EntityType } from '../../../../../pipes/entity-type.pipe';
import {
  ApplicantRegonDataFormComponent
} from './components/applicant-regon-data-form/applicant-regon-data-form.component';

export interface ApplicantDataComponentConfig {
  stages: string[];
  entityType?: EntityType;
  successUrl: string;
  cancelUrl?: string;
}

@Component({
  selector: 'app-applicant-data-section',
  standalone: true,
  imports: [
    CommonModule,
    SpinnerComponent,
    StagesComponent,
    ReactiveFormsModule,
    ValidationErrorsComponent,
    ProxyFormComponent,
    ApplicantPeselDataFormComponent,
    ApplicantNipDataFormComponent,
    ApplicantNoNipAndPeselDataFormComponent,
    ApplicantAddressDataFormComponent,
    NgxMaskDirective,
    ApplicantRegonDataFormComponent
  ],
  templateUrl: './applicant-data-section.component.html',
  providers: [
    ApplicantForm
  ]
})
export class ApplicantDataSectionComponent extends ApplicationCommonComponent implements OnDestroy, OnInit {

  public entityTypes = EntityType;

  public stages: string[] = this.route.snapshot.data['stages'];
  public entityType: EntityType = this.route.snapshot.data['entityType'];

  public successUrl: string = this.route.snapshot.data['successUrl'];
  public cancelUrl: string = this.route.snapshot.data['cancelUrl'];

  public user: Signal<UserDetails | null> = this.store$.selectSignal(selectUser);

  public form: ApplicantForm = inject(ApplicantForm);

  private fetchApplicant = toObservable(this.application).subscribe((data) => {
    this.form.patchFormValues(data);
  });

  public onPastDataFromPortal(): void {
    this.form?.readApplicantDataFromPortal(this.user());
  }

  public onPastDataFromLoginGov(): void {
    this.form?.readApplicantDataFromGovPl(SessionService.GetTokenData());
  }

  public submitAndGoNext(): void {
    if (this.form.valid) {
      this.store$.dispatch(updateApplicantData({
        application: this.application() || {},
        applicationPayload: {
          isFiledByProxy: this.form.isFiledByProxy.value,
          ...this.form.proxyPersonForm?.toWriteModel()
        },
        applicantPayload: this.form.toWriteModel(),
        successFnc: (applicationId) => {
          this.router.navigate(
            [this.successUrl],
            {
              relativeTo: this.route
            }
          );
        },
        failureFnc: () => {
        }
      }));
    } else {
      this.form.markAllAsTouched();
    }
  }

  public override onCancel(): void {
    if (this.cancelUrl) {
      this.router.navigate([this.cancelUrl], { relativeTo: this.route });
    } else {
      super.onCancel();
    }
  }

  public override ngOnInit(): void {
    super.ngOnInit();
    this.form.entityType.setValue(this.entityType || EntityType.OSOBA_FIZYCZNA);
  }

  public override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.fetchApplicant.unsubscribe();
  }
}
